import { DataGrid, GridColDef, GridRowId } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import { usePersistentState, markNavigationPreserve, consumeNavigationPreserve, clearNamespace } from "../../hooks/persistence";
import { CommonService } from "../../Service/CommonService";
import "../Dynamic/UserList.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SearchIcon from "@mui/icons-material/Search";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { IconButton, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
  Form,
  Modal
} from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';
import TrashIcon from "../../assets/images/icons/Trash.svg";
import Constant from "../../Constant";
import { OrderApiService } from "../../Service/OrderApiService";
import Spinner from "../Common/Spinner";
import StatusDropdown from "../Common/StatusDropdown";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import Select from "react-select";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import DataGridLoader from "../Common/DataGridLoader";


const OfferRequest = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [tableData, setTableData] = useState<any[]>([]);
  const [reviewUserCount, setReviewCount] = useState(0);
  const [search, setSearch] = useState("");
  let approved: any[] = [];
  const approvedUserRef = useRef(approved);
  const history = useHistory();
  const disableAction = useRef(false);
  const isNeedReviewClicked = useRef(false);
  const selectedRows = useRef(approved);
  const rejectionNote = useRef("");
  const statusDetailsRef = useRef({ id: "", status: "", rejectionNote: "" ,companyId: "", cancellationReason: "", 
                                    trackNumber: "", quantity: "", ownershipTransferDate: "", assignedTo: ""});
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);
  const [rejectionNoteValue, setNote] = useState<string>("");
  const [selectedWarehouseUser, setSelectedWarehouseUser] = useState<string>("");
  const [error, setError] = useState<string>("");
  const { id } = useParams<{ id: string }>();
  const params = id === undefined ? CommonService.getCompanyId() : id;
  const [files, setFiles] = useState<File[]>([]);
  const[currentStatus, setCurrentStatus] = useState('');
  const toTitleCase = (str: string) => {
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const controllerRef = useRef<AbortController | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [trackNumberValue, setTrackNumber] = useState<string>("");
  const [ownershipTransferDateValue, setOwnershipTransferDate] = useState<string>("");
  const [isRejected, setIsRejected] = useState(false);
  const [isInTransit, setIsInTransit] = useState(false);
  const [isInWarehouse, setIsInWarehouse] = useState(false);
  const [warehouseUserList, setWarehouseUserList] = useState([]);

  const initialFilter = {
    inventoryName: null,
    requestNumber: null,
    companyName: null,
    firstName: null,
    requestedOn: null,
    quantity: null,
    pricePerBarrel: null,
    totalAmount: null,
    status: null,
    modifiedOn: null,
    ownerRequestedOn: null,
    ownerModifiedOn: null,
  };

  const _filterInitRef = useRef(false);
  if (!_filterInitRef.current) {
    _filterInitRef.current = true;
    if (!consumeNavigationPreserve("offer-request")) {
      clearNamespace("offer-request");
    }
  }

  const [page, setPage] = usePersistentState<number>("offer-request", "page", 0);
  const [pageSize, setPageSize] = usePersistentState<number>("offer-request", "pageSize", 50);
  const [sortField, setSortField] = usePersistentState<string>("offer-request", "sortField", "CreatedModifiedDate");
  const [sortDirection, setSortDirection] = usePersistentState<string>("offer-request", "sortDirection", "asc");
  const [filter, setFilter] = usePersistentState<any>("offer-request", "filter", initialFilter);

  const statusOptions = [
    { value: "PENDING_REVIEW", label: "Pending Review" },
    { value: "UNDER_REVIEW", label: "Under Review" },
    { value: "ACCEPTED", label: "Accepted" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "CONTRACT_SENT", label: "Contract Sent"},
    { value: "CONTRACT_EXECUTED", label: "Contract Executed"},
    { value: "PAYMENT_RECEIVED", label: "Payment Received" },
    { value: "INVOICE_SENT", label: "Invoice Sent" },
    { value: "OWNERSHIP_TRANSFERRED", label: "Ownership Transferred"},
    { value: "IN_TRANSIT", label: "In Transit"},
    { value: "REJECTED", label: "Rejected" },
    { value: "CANCELLED", label: "Cancelled" },
    { value: "CLOSED", label: "Closed" },

  ];


  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };

  const fetchAllActiveOfferRequests = async (page:any,size:any, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      setIsLoading(true);
      setTableData([]);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;

      const response = await OrderApiService.getActiveOfferRequests(page,size,false, filter, sortField, sortDirection, signal);
      approved = Object.values(response.data.content); // Convert object to array
      approvedUserRef.current = approved;
      setTotalCount(response.data.totalElements);
      // Access updated value of approvedUser using approvedUserRef.current
      setTableData(approvedUserRef.current);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

   // Toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  }

  const handleRowClick = (params) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    markNavigationPreserve("offer-request");
    history.push(`${linkPrefix}/view-offer-request/${params.row.id}`, { fromInternal: true });
  }

  const openOfferRequests = async (page,size, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      setIsLoading(true);
      setTableData([]);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;

      const response = await OrderApiService.getCompanyWiseOfferRequests(
        params,
        false,CommonService.getDashboardPrefrence(),page, size, filter, sortField, sortDirection, signal
      ); // Applies the status filter only if isFetchOpenRequests is true;

      setTableData(Object.values(response.data.content)); // Convert object to array
      setTotalCount(response.data.totalElements);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
   reloadOfferRequests();
  }, []);

  const reloadOfferRequests = () => {
    if (currentPath === "/master/my-warehouse/offer-request/" + id || currentPath === "/user/my-warehouse/offer-request")
      openOfferRequests(page,pageSize, filter, sortField, sortDirection);
    else 
      fetchAllActiveOfferRequests(page,pageSize, filter, sortField, sortDirection);
  };


  //add tootip
  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString()}>
        <span>{value?.toString()}</span>
      </Tooltip>
    );
  };

  //this code is for dropdown
  const [rowStatusMap, setRowStatusMap] = React.useState<{
    [key: string]: string;
  }>({});

  const [isCancelled, setIsCancelled] = useState(false);
  const [cancellationReason, setCancellationReason] = useState('');


  const handleCancellationReasonChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCancellationReason(event.target.value);
    setError("");

  };

   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
     if (event.target.files) {
       const newFiles = Array.from(event.target.files);
       setFiles((prevFiles) => [...prevFiles, ...newFiles]);

       // Clear the input value to allow selecting the same file again
       event.target.value = "";
     }
   };

   const handleDeleteFile = (indexToDelete: number) => {
     setFiles((prevFiles) =>
       prevFiles.filter((_, index) => index !== indexToDelete)
     );
   };
    
     

  const handleStatusChange = async (newStatus: string, rowId: string, currentStatus:string, quantity:any) => {
    // const statusMap: { [key: string]: string } = {
    //   "1": "Accepted",
    //   "2": "Pending Review",
    //   "3": "Rejected",
    //   "4": "Shipped",
    //   "5": "Cancelled",
    //   "6": "Delivered",
    // };

    // const newStatus = statusMap[eventKey];

    const orderStatus = newStatus?.replace(/ /g, "_");

    //create the object to send
    const sd = {
      id: rowId,
      status: orderStatus.toUpperCase(),
      rejectionNote: rejectionNote.current,
      companyId: CommonService.getCompanyId(),
      cancellationReason: '',
      trackNumber : '',
      ownershipTransferDate: '',
      quantity: quantity,
      assignedTo: selectedWarehouseUser
    };
    
    setCurrentStatus(currentStatus);
    statusDetailsRef.current = sd;
    if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED) {
      setIsRejected(true);
      handleShow();
    } else if(statusDetailsRef.current.status === Constant.OrderStatus.CANCELLED) {
      setIsCancelled(true);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.SEND_TO_WAREHOUSE) {
      setIsInWarehouse(true);
      let response = await OrderApiService.fetchAllWarehouseUser();
      setWarehouseUserList(response.data);
      handleShow();
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT) {
      setIsInTransit(true);
      handleShow();
    } else if (["UNDER_REVIEW", "ACCEPTED", "IN_PROGRESS", "CONTRACT_SENT", "CONTRACT_EXECUTED", "INVOICE_SENT", "PAYMENT_RECEIVED", "OWNERSHIP_TRANSFERRED", "CLOSED"].includes(statusDetailsRef.current.status)) {
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      setIsInTransit(false);
      handleShow();
    } else {
      changeOfferStatus();
    }
  };

  const handleClose = () => {
    setShow(false);
    setError("");
    setNote("");
    setIsCancelled(false);
    setCancellationReason('');
    setIsRejected(false);
    setIsInTransit(false);
    setCurrentStatus('');
    setTrackNumber('');
    setOwnershipTransferDate('');
    setSelectedWarehouseUser("");
    setFiles([]);
  };

  const handleTrackingNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTrackNumber(event.target.value);
    setError("");
  };

  const handleWarehouseUserChange = (selectedOption) => {
    setSelectedWarehouseUser(selectedOption ? selectedOption.value : '');
    setError("");
  };

  const dateInputRef = useRef(null);

  const handleDateClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current?.showPicker(); // This will trigger the date picker to open
    }
  };
  
  const handleOwnershipTransferDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOwnershipTransferDate(event.target.value);
    setError("");
  };

  const uploadOfferRequestDocs = async () => {

    const formData = new FormData();
    let response;
    let offerRequestDoc = {};

    if (files && Array.isArray(files)) {
      files.forEach(function (file: any) {
        formData.append("file", file);
      });
    }

    const fileNames = files.map((file) => file.name).join(", ");

    offerRequestDoc = {
      offerRequestId: id,
      description: "uploaded " + fileNames + " document",
      userId: CommonService.getUserId(),
      title: fileNames,
      companyId: CommonService.getCompanyId(),
    };

    formData.append(
      "param",
      new Blob([JSON.stringify(offerRequestDoc)], {
        type: "application/json",
      })
    );

    response = await OrderApiService.uploadOfferRequestDocs(formData);

  };

  useEffect(() => {
  
  const handleClickOutside = (event: MouseEvent) => {
    if (
        divRef.current &&
        !divRef.current.contains(event.target as Node) &&
        buttonRef.current &&
          !buttonRef.current.contains(event.target as Node)
        ) {
          setShowDropdown(false);  
        }
      }; 
        
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);  
      };
      
  }, [showDropdown]); // Only run when dropdown is toggled

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const changeOfferStatus = async () => {
    if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED && rejectionNoteValue.trim().length == 0) {
      setError("Please enter rejection note");
      return;
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.REJECTED && rejectionNoteValue.trim().length > 500) {
      setError("Rejection note can not be more than 500 characters");
      return;
    } else if(statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT && trackNumberValue.trim().length == 0) {
      setError("Please enter track number");
      return;
    } else if(statusDetailsRef.current.status === Constant.OrderStatus.SEND_TO_WAREHOUSE && selectedWarehouseUser == "") {
      setError("Please Select Warehouse");
      return;
    } else if (statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED) {
        if(ownershipTransferDateValue.trim().length === 0){
          setError("Please enter date of transfer");
          return;
        }
  
        const transferDate = new Date(ownershipTransferDateValue);
        const today = new Date(CommonService.getTodayInTimeZone());
        today.setHours(0, 0, 0, 0);
        transferDate.setHours(0, 0, 0, 0);
  
        if (transferDate < today) {
          setError("Ownership transfer date cannot be in the past.");
          return;
        }
    }

    try {
      setIsLoading(true);
      statusDetailsRef.current.rejectionNote = rejectionNote.current;
      statusDetailsRef.current.cancellationReason = cancellationReason;
      statusDetailsRef.current.trackNumber = trackNumberValue;
      statusDetailsRef.current.ownershipTransferDate = ownershipTransferDateValue;
      statusDetailsRef.current.assignedTo = selectedWarehouseUser;
      await OrderApiService.changeOfferStatus(statusDetailsRef.current);

      // Reload updated offer requests
      reloadOfferRequests();

      if (statusDetailsRef.current.status === Constant.OrderStatus.IN_TRANSIT
        && (files.length > 0)) {
       uploadOfferRequestDocs();
      }

      CommonService.Toast.fire({
        title: "Offer status updated successfully",
        icon: "success",
      });
    } catch (error) {

      const errorMessage = error?.response?.data?.errorMessage ?? "";

      if (errorMessage.includes("Not enough container available for reservation for Offer Request")) {
        CommonService.Toast.fire({
          title: "Out of Stock, please change quantity",
          icon: "error",
        });
      }

      if (errorMessage.includes("Please select the required quantity")) {
        CommonService.Toast.fire({
          title: "Please select the container to match the quantity",
          icon: "error",
        });
      }
    } finally {
      setIsLoading(false);
      handleClose();
    }
  };

  //formate the status
  function formatStatus(status: string): string {
    const formattedStatus = status
      .split(/[_\\]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
    return formattedStatus;
  }

  const getStatusOptions = () => {
    const profile = CommonService.getDashboardPrefrence();
    
    // Return all options for SUPER_ADMIN
    if (CommonService.getRole() === Constant.Role.SUPER_ADMIN) {
      return statusOptions;
    }
    
    // Filter options based on profile
    switch (profile) {
      case Constant.Profile.BUYER:
        return statusOptions; // Buyer sees all options
      case Constant.Profile.OWNER:
        // Owner only sees specific statuses
        return statusOptions.filter(option => 
          ["PENDING_REVIEW", "ACCEPTED", "REJECTED"].includes(option.value)
        );
      default:
        break;
    }
  };

  const columns: GridColDef[] = [
    {
      field: "requestNumber",
      headerName: "Request Number",
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.requestNumber}
              defaultValue={filter.requestNumber}
              onChange={(event) => handleFilterChange(event, "requestNumber")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
      minWidth: 170,
      flex:1,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value || '-'}/>
    },
    {
      field: "inventoryName",
      headerName: "Inventory",
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.inventoryName}
              defaultValue={filter.inventoryName}
              onChange={(event) => handleFilterChange(event, "inventoryName")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
      minWidth: 170,
      flex:1,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value}/>
    },
    ...(CommonService.isAdmin()
      ? [
        {
          field: "companyName",
          headerName: "Account Owner Name",
          headerClassName: "table-header border-0 my-2 h-100",
          renderHeader: (params) => (
            <div>
              <Typography
                variant="body2"
                sx={{ color: "#6F6F6F", fontSize: "14px" }}
              >
                {params.colDef.headerName}
              </Typography>
              <div className="position-relative" style={{ width: "120px" }}>
                <input
                  type="text"
                  className="form-control border mt-1"
                  style={{ textIndent: "24px", boxShadow: "none" }}
                  placeholder="Search"
                  //value={filter.companyName}
                  defaultValue={filter.companyName}
                  onChange={(event) =>
                    handleFilterChange(event, "companyName")
                  }
                  onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                />
                <SearchIcon
                  sx={{
                    color: "#6F6F6F",
                    position: "absolute",
                    top: "50%",
                    left: "8px",
                    transform: "translateY(-50%)",
                  }}
                />
              </div>
            </div>
          ),
          minWidth: 170,
          flex: 1,
          sortable: true,
          renderCell: (params: any) => <CellWithTooltip value={params.value} />,
        }]
    : []),
    {
      field: "modifiedDate",
      headerName: "Modified On",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 170,
      flex:1,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value} />,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.modifiedDate ? row.modifiedDate : null;
        const sellerModifiedDateTimeString = row.ownerOrderModifiedDate
          ? row.ownerOrderModifiedDate
          : null;

        if (dateTimeString) {
          //call the method which formate the time
          return CommonService.isUser() &&
            !CommonService.isSameCompany(row.companyId)
            ? CommonService.formatDateTime(sellerModifiedDateTimeString)
            : CommonService.formatDateTime(dateTimeString);
        }
      },
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="date"
              className="form-control border mt-1"
              style={{ boxShadow: "none" }}
              id="birthdate"
              name="modifiedDate"
              placeholder="MM/DD/YYYY"
              //value={filter.modifiedOn}
              defaultValue={
                CommonService.isUser() &&
                CommonService.getDashboardPrefrence() === Constant.Profile.OWNER
                  ? filter.ownerModifiedOn
                  : filter.modifiedOn
              }
              onChange={(event) =>
                handleFilterChange(
                  event,
                  CommonService.isUser() &&
                    CommonService.getDashboardPrefrence() ===
                      Constant.Profile.OWNER
                    ? "ownerModifiedOn"
                    : "modifiedOn"
                )
              }
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
          </div>
        </div>
      ),
    },
    {
      field: "createdDate",
      headerName: "Requested On",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 170,
      flex:1,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value} />,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.createdDate ? row.createdDate : null;
        const sellerCreatedDateTimeString = row.ownerOrderCreatedDate
          ? row.ownerOrderCreatedDate
          : null;

        if (dateTimeString) {
          //call the method which formate the time
          return CommonService.isUser() &&
            !CommonService.isSameCompany(row.companyId)
            ? CommonService.formatDateTime(sellerCreatedDateTimeString)
            : CommonService.formatDateTime(dateTimeString);
        }
      },
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="date"
              className="form-control border mt-1"
              style={{ boxShadow: "none" }}
              id="birthdate"
              name="birthdate"
              placeholder="MM/DD/YYYY"
              //value={filter.requestedOn}
              defaultValue={
                CommonService.isUser() &&
                CommonService.getDashboardPrefrence() === Constant.Profile.OWNER
                  ? filter.ownerRequestedOn
                  : filter.requestedOn
              }
              onChange={(event) =>
                handleFilterChange(
                  event,
                  CommonService.isUser() &&
                    CommonService.getDashboardPrefrence() ===
                      Constant.Profile.OWNER
                    ? "ownerRequestedOn"
                    : "requestedOn"
                )
              }
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
          </div>
        </div>
      ),
    },
    ...(CommonService.isAdmin()
      ? [{
        field: "firstName",
        headerName: "Requested By",
        flex: 1,
        sortable: true,
        minWidth: 170,
        valueGetter: (value: any, row: any) =>
          `${row.firstName || ""} ${row.lastName || ""}`,
        headerClassName: "table-header border-0 my-2 h-100",
        renderHeader: (params) => (
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: "120px" }}>
              <input
                type="text"
                className="form-control border mt-1"
                style={{ textIndent: "24px", boxShadow: "none" }}
                placeholder="Search"
                //value={filter.firstName}
                defaultValue={filter.firstName}
                onChange={(event) => handleFilterChange(event, "firstName")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              />
              <SearchIcon
                sx={{
                  color: "#6F6F6F",
                  position: "absolute",
                  top: "50%",
                  left: "8px",
                  transform: "translateY(-50%)",
                }}
              />
            </div>
          </div>
        ),
        renderCell: (params: any) => <CellWithTooltip value={params.value} />,
      }]
      : []),
    ...(!CommonService.isAdmin() && CommonService.getDashboardPrefrence() == "Buyer"
      ? [
        {
          field: "firstName",
          headerName: "Requested By",
          minWidth: 170,
          flex: 1,
          sortable: true,
          valueGetter: (value: any, row: any) =>
            `${row.firstName || ""} ${row.lastName || ""}`,
          headerClassName: "table-header border-0 my-2 h-100",
          renderHeader: (params) => (
            <div>
              <Typography
                variant="body2"
                sx={{ color: "#6F6F6F", fontSize: "14px" }}
              >
                {params.colDef.headerName}
              </Typography>
              <div className="position-relative" style={{ width: "120px" }}>
                <input
                  type="text"
                  className="form-control border mt-1"
                  style={{ textIndent: "24px", boxShadow: "none" }}
                  placeholder="Search"
                  //value={filter.firstName}
                  defaultValue={filter.firstName}
                  onChange={(event) => handleFilterChange(event, "firstName")}
                  onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                />
                <SearchIcon
                  sx={{
                    color: "#6F6F6F",
                    position: "absolute",
                    top: "50%",
                    left: "8px",
                    transform: "translateY(-50%)",
                  }}
                />
              </div>
            </div>
          ),
          renderCell: (params: any) => (
            <CellWithTooltip value={params.value} />
          ),
        },
      ]
      : []),
    {
      field: "quantity",
      headerName: "Quantity",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 140,
      flex:1,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value} />,
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "110px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.quantity}
              defaultValue={filter.quantity}
              onChange={(event) => handleFilterChange(event, "quantity")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    {
      field: "pricePerBarrel",
      headerName: "Offered Price",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 150,
      flex:1,
      sortable: true,
      renderCell: (params: any) => (
        <CurrencyFormatter
          amount={params.value}
          locale="en-US"
          currency="USD"
        />
      ),
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.pricePerBarrel}
              defaultValue={filter.pricePerBarrel}
              onChange={(event) => handleFilterChange(event, "pricePerBarrel")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    {
      field: "totalAmount",
      headerName: "Total Price",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 150,
      flex:1,
      sortable: true,
      renderCell: (params: any) => (
        <CurrencyFormatter
          amount={params.value}
          locale="en-US"
          currency="USD"
        />
      ),
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.totalAmount}
              defaultValue={filter.totalAmount}
              onChange={(event) => handleFilterChange(event, "totalAmount")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "table-header border-0 my-2 h-100",
      cellClassName: "status-badge",
      minWidth: 240,
      flex: 1,
      sortable: true,
      renderCell: (params: any) => (
        <div
          className="cell-with-dropdown mb-2"
          onClick={(e) => e.stopPropagation()}
        >
          {(params.row?.status === "PENDING_REVIEW" ||
            params.row?.status === "UNDER_REVIEW") && (
              <StatusDropdown
                currentStatus={params.row.status}
                onStatusChange={(newStatus) =>
                  handleStatusChange(
                    newStatus,
                    params.row.id,
                    params.row?.status,
                    params.row?.quantity
                  )
                }
                disableCondition={
                  (!CommonService.isSameCompany(params.row?.companyId) &&
                    CommonService.isUser()) ||
                  (!CommonService.isSameUser(params.row?.createdBy) &&
                    CommonService.isSameCompany(params.row?.companyId) &&
                    CommonService.getRole() === Constant.Role.USER)
                }
                allowedLabels={
                  CommonService.isUser()
                    ? ["Cancelled"]
                    : params.row?.hasValidStatus
                      ? ["Under Review", "Rejected"]
                      : params.row?.hasItemRejected
                        ? ["Under Review", "Rejected"]
                        : ["Under Review", "Accepted", "Rejected"]
                }
              />
            )}

          {/* Accepted to Payment Received - Both User and Admin */}
          {[
            "ACCEPTED",
            "IN_PROGRESS",
            "CONTRACT_SENT",
            "INVOICE_SENT",
            "CONTRACT_EXECUTED",
            "PAYMENT_RECEIVED",
          ].includes(params.row?.status) && (
              <StatusDropdown
                currentStatus={formatStatus(params.row?.status)}
                onStatusChange={(newStatus) =>
                  handleStatusChange(
                    newStatus,
                    params.row.id,
                    params.row?.status,
                    params.row?.quantity
                  )
                }
                disableCondition={
                  (!CommonService.isSameCompany(params.row?.companyId) &&
                    CommonService.isUser()) ||
                  (!CommonService.isSameUser(params.row?.createdBy) &&
                    CommonService.isSameCompany(params.row?.companyId) &&
                    CommonService.getRole() === Constant.Role.USER)
                }
                allowedLabels={
                  CommonService.isAdmin()
                    ? [
                      "In Progress",
                      "Contract Sent",
                      "Contract Executed",
                      "Invoice Sent",
                      "Payment Received",
                      "Ownership Transferred",
                      "Rejected",
                    ]
                    : ["Cancelled"]
                }
              />
            )}

          {params.row?.status === "OWNERSHIP_TRANSFERRED" && (
            <StatusDropdown
              currentStatus={formatStatus(params.row?.status)}
              onStatusChange={(newStatus) =>
                handleStatusChange(
                  newStatus,
                  params.row.id,
                  params.row?.status,
                  params.row?.quantity
                )
              }
              disableCondition={CommonService.isUser()}
              allowedLabels={[
                "Send to Warehouse"
              ]}
            />
          )}

          {["SEND_TO_WAREHOUSE", "IN_PROCESS"].includes(params.row?.status) && (
            <StatusDropdown
              currentStatus={formatStatus(params.row?.status)}
              onStatusChange={(newStatus) =>
                handleStatusChange(
                  newStatus,
                  params.row.id,
                  params.row?.status,
                  params.row?.quantity
                )
              }
              disableCondition={CommonService.isUser()}
              allowedLabels={
                CommonService.isAdmin()
                  ? [
                    "Admin Accepted for Warehouse"
                  ]
                  : [
                    "In Process",
                    "Reassign to Admin",
                    "Warehouse Completed"
                  ]
              }
            />
          )}

          {["ADMIN_ACCEPTED_FOR_WAREHOUSE", "REASSIGN_TO_ADMIN", "WAREHOUSE_COMPLETED"].includes(params.row?.status) && (
            <StatusDropdown
              currentStatus={formatStatus(params.row?.status)}
              onStatusChange={(newStatus) =>
                handleStatusChange(
                  newStatus,
                  params.row.id,
                  params.row?.status,
                  params.row?.quantity
                )
              }
              disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
              allowedLabels={[
                ...(params.row?.status === "REASSIGN_TO_ADMIN") ? ["Send to Warehouse"] : [],
                ...(params.row.relocationFlag ? ["In Transit"] : []),
                "Closed",
              ]}
            />
          )}

          {params.row?.status === "IN_TRANSIT" && (
            <StatusDropdown
              currentStatus={formatStatus(params.row?.status)}
              onStatusChange={(newStatus) =>
                handleStatusChange(
                  newStatus,
                  params.row.id,
                  params.row?.status,
                  params.row?.quantity
                )
              }
              disableCondition={CommonService.isWarehouse() || CommonService.isUser()}
              allowedLabels={["Closed"]}
            />
          )}

          {(params.row?.status === "REJECTED" ||
            params.row?.status === "CLOSED") && (
              <StatusDropdown
                currentStatus={formatStatus(params.row?.status)}
                onStatusChange={(newStatus) => {
                  handleStatusChange(
                    newStatus,
                    params.row.id,
                    params.row?.status,
                    params.row?.quantity
                  );
                }}
                disableCondition={true}
                allowedLabels={[]}
              />
            )}

          {(params.row?.status === "CANCELLED") && (
              <StatusDropdown
                currentStatus={formatStatus(params.row?.status)}
                onStatusChange={(newStatus) => {
                  handleStatusChange(
                    newStatus,
                    params.row.id,
                    params.row?.status,
                    params.row?.quantity
                  );
                }}
                disableCondition={CommonService.isWarehouse() || CommonService.isUser()}
                allowedLabels={['Closed']}
              />
            )}

          {params.row.status === "REJECTED" && params.row?.rejectionNote && (
            <Tooltip
              title={`Rejection Note: ${params.row?.rejectionNote}`}
              arrow
            >
              <StickyNote2Icon
                className="note-icon cursor-pointer"
                style={{ color: "gray" }}
              />
            </Tooltip>
          )}
          {params.row.status === "CANCELLED" &&
            params.row?.cancellationReason && (
              <Tooltip
                title={`Cancellation Reason: ${params.row?.cancellationReason}`}
                arrow
              >
                <StickyNote2Icon
                  className="note-icon cursor-pointer"
                  style={{ color: "gray" }}
                />
              </Tooltip>
            )}
        </div>
      ),
      renderHeader: (params) => (
        <>
          {/* <div>
                <Typography
                    variant="body2"
                    sx={{ color: "#6F6F6F", fontSize: "14px" }}
                >
                    {params.colDef.headerName}
                </Typography>
                <div className="position-relative" style={{width:"120px"}}>
                    <Form.Select
                        style={{ cursor: "pointer",borderBottomColor:"#D1D1D1",marginTop:"4px" }}
                        value={filter.status}
                        className="form-control mb-1"
                        onChange={(event) => handleFilterChange(event, "status")}
                        onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    >
                        <option value="">Select Status</option>
                        {getStatusOptions()}
                    </Form.Select>
                </div>
            </div> */}

          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>

            <div className="position-relative" style={{ width: "200px" }}>
              <div
                className="form-control mb-1"
                style={{
                  cursor: "pointer",
                  borderBottomColor: "#D1D1D1",
                  marginTop: "4px",
                  background: "#fff",
                  padding: "5px",
                  overflowX: "hidden",
                  paddingRight: "16px",
                  textOverflow: "ellipsis",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  toggleDropdown();
                }}
                ref={buttonRef}
              >
                {filter.status?.length > 0
                  ? CommonService.formatStatus(filter.status).join(", ")
                  : "Select Status"}

                <img src={ExpandMore} className="position-absolute top-50 end-0 translate-middle" />

              </div>

              {/* Custom Dropdown */}
              {showDropdown && (
                <div
                  className="dropdown-menu show status-multiselect-dropdown"
                  onClick={(event) => event.stopPropagation()}
                  ref={divRef}
                >
                  {getStatusOptions().map((option) => (
                    <Form.Check
                      key={option.value}
                      id={`status-${option.value}`}
                      type="checkbox"
                      label={option.label}
                      value={option.value}
                      checked={
                        filter.status?.split(",").includes(option.value) ||
                        false
                      }
                      onChange={(event) => {
                        event.stopPropagation();
                        handleStatusFilterChange(
                          event,
                          option.value,
                          filter.status
                        );
                      }}
                      className="cursor-pointer"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      ),
    },
  ];
//.filter(Boolean) as GridColDef[]
  const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);

  const handleSelectionModelChange = (newSelection: GridRowId[]) => {
    setSelectionModel(newSelection);
    const newSelectedRows = newSelection.map((id: GridRowId) => {
      return tableData.find((row: any) => row.id === id); // Assuming each row object has an 'id' property
    });
    selectedRows.current = newSelectedRows;
    let flag: any = false;
    flag = selectedRows.current.some((user) => user.status === "INVITED");
    disableAction.current = flag;
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(event.target.value);
    setError("");
    rejectionNote.current = event.target.value;
  };

  // // Filter rows based on search query
  // const filteredRows = tableData.filter((row) =>
  //   CommonService.isAdmin()
  //     ? row.companyName?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.firstName?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.lastName?.toLowerCase().includes(search?.toLowerCase()) ||
  //       row.inventoryName?.toLowerCase().includes(search?.toLowerCase()) ||
  //       (row.firstName + " " + row.lastName)
  //         .toLowerCase()
  //         .includes(search?.toLowerCase())
  //     : row.inventoryName?.toLowerCase().includes(search?.toLowerCase())
  // );

  // Map filtered rows with unique IDs
  const tableDataWithIds = tableData.map((rowData, index) => ({
    ...rowData,
  }));

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, field: keyof any) => {
    const value = event.target.value;

    // Prepare a temporary filter object with the updated field value
    const tempFilter = {
      ...filter, // Spread existing filter state
      [field]: field === "status" && value === "" ? null : value, // Update field only if the condition is met
    };
  
    // Update the filter state
    setFilter(tempFilter);

    // Load the service requests with updated filters
    if (currentPath === "/master/my-warehouse/offer-request/" + id || currentPath === "/user/my-warehouse/offer-request")
      openOfferRequests(page,pageSize, tempFilter, sortField, sortDirection);
    else 
      fetchAllActiveOfferRequests(page,pageSize, tempFilter, sortField, sortDirection);
  };

  const handleStatusFilterChange = (event: any, value: string, status: string | null) => {
    const isChecked = event.target.checked;
  
    // Convert the status string to an array
    const statusArray = status ? status.split(",") : [];
  
    // Update the status list based on checkbox state
    const updatedStatusArray = isChecked
      ? [...statusArray, value] // Add status if checked
      : statusArray.filter((s) => s !== value); // Remove status if unchecked
  
    // Convert array back to a comma-separated string
    const updatedStatus = updatedStatusArray?.length > 0 ? updatedStatusArray.join(",") : null;
  
    // Update the filter state with the modified status string
    setFilter({ ...filter, status: updatedStatus });
  
     // Load the service requests with updated filters
     if (currentPath === "/master/my-warehouse/offer-request/" + id || currentPath === "/user/my-warehouse/offer-request")
        openOfferRequests(page,pageSize, { ...filter, status: updatedStatus }, sortField, sortDirection);
     else
        fetchAllActiveOfferRequests(page,pageSize, { ...filter, status: updatedStatus }, sortField, sortDirection);
  };

  const handleBack = () => {
    if (currentPath.startsWith("/master/offer-request")) {
      history.push(`/master/service-requests-and-queue`);
    } else if (currentPath.startsWith("/master/my-warehouse/offer-request/"))
      history.push(`/master/my-warehouse/service-requests/` + id);

    // history.goBack();
  };

  const onPaginationModelChange = (newPaginationModel) => {
    setPage(newPaginationModel.page);
    setPageSize(newPaginationModel.pageSize);

    if (currentPath === "/master/my-warehouse/offer-request/" + id || currentPath === "/user/my-warehouse/offer-request")
      openOfferRequests(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    else 
      fetchAllActiveOfferRequests(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
  };

  const handleSortChange = (sortModel) => {
    if (sortModel.length > 0) {
        const newSortField = sortModel[0].field;
        const newSortDirection = sortModel[0].sort; // "asc" or "desc" directly from DataGrid
        
        setSortField(newSortField);
        setSortDirection(newSortDirection);
        
        if (currentPath === "/master/my-warehouse/offer-request/" + id || currentPath === "/user/my-warehouse/offer-request")
          openOfferRequests(page,pageSize, filter, newSortField, newSortDirection);
        else 
          fetchAllActiveOfferRequests(page,pageSize, filter, newSortField, newSortDirection);
    }
  };  

  return (
    <>
      <div className="usersList" style={{paddingBottom:CommonService.isAdmin() ? 53 : ""}}>
        <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center">
        {CommonService.isAdmin() && (<IconButton
                  onClick={handleBack}
                  aria-label="ArrowBackIcon"
                  sx={{
                    backgroundColor: "#FFF",
                    "&:hover": { backgroundColor: "#FFF" },
                  }}
                >
                  <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                </IconButton>)}
          {CommonService.isAdmin() && (<div className="header--title me-2">
            <h1 className="title mb-0 ms-2">
              Offer Requests
            </h1>
          </div>)}
          <div className="header--menu ms-auto mb-2">
            <div className="header--menu-items row d-flex justify-content-end">
              <div className="col-auto mb-2">
                {/* <SearchBar search={search} setSearch={setSearch} /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="user-table-container">
          <div className="userTable">
          <DataGrid
            rows={tableDataWithIds}
            columns={columns}
            className="data-grid support-req--listing"
            initialState={{
              pagination: {
                  paginationModel: { page, pageSize },
              },
            }}
            pagination
            paginationModel={{page, pageSize }}
            rowCount={totalCount}
            paginationMode="server"
            sortingMode="server"
            onSortModelChange={handleSortChange}
            onPaginationModelChange={onPaginationModelChange}
            pageSizeOptions={[10, 20, 50, 100]}
            localeText={localeText}
            // checkboxSelection
            disableRowSelectionOnClick={true}
            rowSelectionModel={selectionModel}
            onRowSelectionModelChange={handleSelectionModelChange}
            onRowClick={handleRowClick}
            loading={isLoading}
            slots={{
              loadingOverlay: DataGridLoader,
            }}
            disableColumnResize
            // getRowClassName={getRowClassName}
          />
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >
        <Modal.Header className="flex-column align-items-start">
          <Modal.Title>Update Offer Request Status</Modal.Title>
          <p className="modal-text mt-2">
            {isCancelled && ((["PENDING_REVIEW", "UNDER_REVIEW"].includes(currentStatus)) ? "Are you sure you want to cancel?" : "Are you sure you want ot cancel? A cancellation charge may apply.")}
            {isInTransit && ("Please enter Tracking Number")}
            {statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED && "Please Enter Date of transfer"}
            {statusDetailsRef.current.status === Constant.OrderStatus.CLOSED && "Once the request is closed, it cannot be reopened. Are you sure you want to close it?"}
            {!isInTransit && !isCancelled && !["OWNERSHIP_TRANSFERRED", "CLOSED"].includes(statusDetailsRef.current.status) && 
                  `Are you sure you want to change status to ${formatStatus(statusDetailsRef.current.status)}?`
            }
          </p>
        </Modal.Header>
        {["OWNERSHIP_TRANSFERRED", "SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.status) && (
        <Modal.Body>
          <div className="form__inner">
          {isCancelled && (
            <textarea
            className={`form-control ${error ? "is_invalid" : ""}`}
            aria-label="With textarea"
            value={cancellationReason}
            onChange={handleCancellationReasonChange}
            rows={8}
            style={{ resize: "none" }}
            placeholder="Enter Cancellation Reason..."
          />
          )}
          {isRejected &&(<textarea
              className={`form-control ${error ? "is_invalid" : ""}`}
              aria-label="With textarea"
              value={rejectionNoteValue}
              onChange={handleInputChange}
              rows={8}
              style={{ resize: "none" }}
              placeholder="Enter rejection note ..."
          />)}
           {isInWarehouse && (
              <div className="form__inner">
                <label className="modal-body__title mb-1">Select Warehouse</label>
                <Select
                  className={`select-company-dropdown form-control w-100 multi-select-dropdown ${error ? "is_invalid" : ""
                    }`}
                  options={warehouseUserList.map((user) => ({
                    value: user.userId,
                    label: user.userName,
                  }))}
                  onChange={handleWarehouseUserChange}
                  components={{
                    DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                    IndicatorSeparator: () => null, // Remove the default separator
                  }}
                  isSearchable
                  placeholder="Select Warehouse"
                />
              </div>
            )}
            {isInTransit && (<><label className="modal-body__title mb-1">Track Number</label><Form.Control
              className={`form-control ${error ? "is_invalid" : ""}`}
              type="text"
              value={trackNumberValue}
              onChange={handleTrackingNumberChange}
              placeholder="Enter Tracking Number..." />
            </>
            )}
            {statusDetailsRef.current.status === Constant.OrderStatus.OWNERSHIP_TRANSFERRED && <>
              <label className="modal-body__title mb-1">Date of transfer</label>
              <Form.Control
                type="date"
                placeholder="OwnershipTransferDate"
                value={ownershipTransferDateValue}
                onChange={handleOwnershipTransferDateChange}
                onClick={handleDateClick}
                className={`form-control ${error ? "is_invalid" : ""}`}
                min={CommonService.getTodayInTimeZone()}
              /></>}
            {error && <div className="error-message">{error}</div>}

            {isInTransit && (<div className="d-flex align-items-center h-100 mt-2">
              <div className="create-ticket-attachement-wrapper d-flex flex-wrap align-items-center gap-1">
                <IconButton
                  type="button"
                  aria-label="submit"
                  sx={{
                    transform: "rotate(45deg)",
                    padding: "8px",
                  }}
                  onClick={handleButtonClick}
                >
                  <AttachFileIcon />
                </IconButton>
                <span className="cursor-pointer" onClick={handleButtonClick}>
                  Upload Document
                </span>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  {files?.map((file, index) => (
                    <div
                      className="file__upload--info d-flex align-items-center mb-1 me-2"
                      key={index}
                    >
                      <div className="file-name me-3">{file.name}</div>
                      <div className="file-delete">
                        <img
                          src={TrashIcon}
                          alt="TrashIcon"
                          onClick={() => handleDeleteFile(index)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ position: "relative" }}>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    multiple
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>
            )}
          </div>
        </Modal.Body>
        )}
        <Modal.Footer className={`justify-content-center 
                  ${["OWNERSHIP_TRANSFERRED", "SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.status) ? '' : 'bg-transparent'}`}>
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <button className="secondary-btn w-100" onClick={handleClose} disabled={isLoading}>
              No
              </button>
            </div>

            <div className="col-6 pe-0">
              <button className="primary-btn w-100" onClick={changeOfferStatus} disabled={isLoading}>
            {isLoading && <Spinner />} {isCancelled ? "Cancel Request" : isRejected ? "Reject Request" : "Yes"}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OfferRequest;
